import { configureStore } from "@reduxjs/toolkit";
import appStateSlice from "./features/appStateSlice";
import userReducer from "./userSlice";

export const store = configureStore({
  reducer: {
    appState: appStateSlice,
    auth: userReducer,
  }
});

export type RootState = ReturnType<typeof store.getState>;